import { ThirdPartyScripts } from '#types';

export function getThirdPartyScriptsGlobal(): ThirdPartyScripts {
  const win = window ?? {};
  return win as ThirdPartyScripts;
}

export function initializeBraze() {
  if (process.env.NEXT_PUBLIC_BRAZE_ENABLED === 'true') {
    const API_KEY = process.env.NEXT_PUBLIC_BRAZE_API_KEY;
    const SDK_ENDPOINT = process.env.NEXT_PUBLIC_BRAZE_SDK_ENDPOINT;
    const enableLogging = process.env.NEXT_PUBLIC_BRAZE_ENABLE_LOGGING;
    const pushNotificationDomain =
      process.env.NEXT_PUBLIC_BRAZE_PUSH_NOTIFICATION_DOMAIN;
    let resolveOnBrazeInitialize = (_t: unknown) => {};
    // biome-ignore lint/suspicious/noExplicitAny: third party script
    let rejectOnBrazeInitialize = (_reason?: any) => {};
    getThirdPartyScriptsGlobal().hackyOnBrazeInitialize = new Promise(
      (resolve, reject) => {
        resolveOnBrazeInitialize = resolve;
        rejectOnBrazeInitialize = reject;
      },
    );

    // https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#install-cdn
    (function (_a, p, P, b, y, API_KEY, SDK_ENDPOINT, enableLogging) {
      const BRAZE_FIELDS =
        'BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.emoveFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction';

      // biome-ignore lint/suspicious/noExplicitAny: third party script
      const braze = {} as any;
      getThirdPartyScriptsGlobal().braze = braze;
      getThirdPartyScriptsGlobal().brazeQueue = [];
      const s = BRAZE_FIELDS.split(' ');

      for (let i = 0; i < s.length; i++) {
        const m = s[i];
        let k = braze;
        // biome-ignore lint/suspicious/noTsIgnore: needed for otter-next
        // @ts-ignore
        const l = m.split('.');
        let j = 0;

        for (; j < l.length - 1; j++) {
          // biome-ignore lint/suspicious/noTsIgnore: needed for otter-next
          // @ts-ignore
          k = k[l[j]];
        }

        // biome-ignore lint/suspicious/noTsIgnore: needed for otter-next
        // @ts-ignore
        k[l[j]] = new Function(
          'return function ' +
            // biome-ignore lint/suspicious/noTsIgnore: needed for otter-next
            // @ts-ignore
            m.replace(/\./g, '_') +
            '(){window.brazeQueue.push(arguments); return true}',
        )();
      }

      braze.getCachedContentCards = function () {
        return new braze.ContentCards();
      };

      braze.getCachedFeed = function () {
        return new braze.Feed();
      };

      braze.getUser = function () {
        return new braze.User();
      };

      const yElement = p.createElement(P);
      // @ts-expect-error
      yElement.type = 'text/javascript';
      // @ts-expect-error FIXME: TS18047
      y.async = 1;
      // @ts-expect-error FIXME: TS18047
      y.src = 'https://js.appboycdn.com/web-sdk/4.8/braze.min.js';

      // @ts-expect-error FIXME: TS18047
      y.onload = () => {
        // @ts-expect-error FIXME: TS18047
        if (window.brazeQueue) {
          // initialize the SDK
          const didInit = braze.initialize(API_KEY, {
            baseUrl: SDK_ENDPOINT,
            enableLogging,
            safariWebsitePushId: pushNotificationDomain,
            allowUserSuppliedJavascript: true,
          });

          if (!didInit) {
            rejectOnBrazeInitialize('Failed to initialize Braze SDK');
            return;
          }
          resolveOnBrazeInitialize(braze);

          // optionally show all in-app messages without custom handling
          // braze.automaticallyShowInAppMessages();

          // if you use Content Cards
          // braze.subscribeToContentCardsUpdates(function (cards) {
          // cards have been updated
          // });

          // Be sure to remove calls to braze.automaticallyShowInAppMessages()
          // from your code as noted in the steps above

          // @ts-expect-error FIXME: TS7006
          braze.subscribeToInAppMessage(function (inAppMessage) {
            let shouldDisplay = true;

            if (inAppMessage instanceof braze.InAppMessage) {
              // Read the key-value pair for msg-id
              const msgId = inAppMessage.extras['msg-id'];

              // If this is our push primer message
              if (msgId === 'push-primer') {
                // We don't want to display the soft push prompt to users on browsers that don't support push, or if the user
                // has already granted/blocked permission
                if (
                  !braze.isPushSupported() ||
                  // braze.isPushPermissionGranted() ||
                  braze.isPushBlocked()
                ) {
                  shouldDisplay = false;
                }
                if (inAppMessage.buttons[0] !== null) {
                  // Prompt the user when the first button is clicked
                  inAppMessage.buttons[0].subscribeToClickedEvent(function () {
                    braze.requestPushPermission();
                  });
                }
              }
            }

            // Display the message
            if (shouldDisplay) {
              braze.showInAppMessage(inAppMessage);
            }
          });
        }
      };

      const bElement = p.getElementsByTagName(P)[0];
      // @ts-expect-error
      bElement.parentNode.insertBefore(y, b);
    })(
      window,
      document,
      'script',
      null,
      null,
      API_KEY,
      SDK_ENDPOINT,
      enableLogging,
    );
  }
}
